import { render, staticRenderFns } from "./AddBaseCarDialog.vue?vue&type=template&id=13e4fb70&scoped=true&"
import script from "./AddBaseCarDialog.vue?vue&type=script&lang=js&"
export * from "./AddBaseCarDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddBaseCarDialog.vue?vue&type=style&index=0&id=13e4fb70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4fb70",
  null
  
)

export default component.exports